import React from 'react';
import { Table } from 'react-bootstrap';

const JcTw = props => {

    return (
        <div className="swingintopfwd">
            <br />
            <div className="container">
                <Table align="center" striped bordered >
                    <thead>
                        <tr>
                            <th><a href="https://www.twitch.tv/joy_collision" >Joy_Collision on Twitch</a></th>
                        </tr>
                    </thead>
                    <tbody >
                        <tr>
                            <td>
                            <iframe title="Joy Twitch" src="https://player.twitch.tv/?channel=joy_collision" scrolling="no" height="378" width="620"></iframe>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        </div>
    )

}

export default JcTw;
